// extracted by mini-css-extract-plugin
module.exports = {"posts__wrapp":"f_q"};